import abp from 'abp';
import { notify, localize } from 'linksoft';
const Resx = localize('App', 'Common');

export default class {

    constructor(apiOptions) {
        this._options = apiOptions;
        this._projectId = apiOptions.projectId;
    }

    load() {
        const url = `/${this._options.loadUrl}/${this._projectId}`;

        return abp.ajax({
            url: url,
            type: 'GET'
        }).fail(err => {
            console.error(err);
            notify(Resx.Common.Error);
        });
    }

    create(createRows, rowCreatedCallback) {
        const url = `/${this._options.createUrl}/${this._projectId}`;
        for (let i = 0; i < createRows.length; i++) {
            const item = createRows[i];
            abp.ajax({
                url: url,
                type: "POST",
                data: JSON.stringify(item.data,
                    (k, v) => {
                        if (v === undefined) {
                            return null;
                        }
                        return v;
                    })
            }).done((id) => {
                rowCreatedCallback(item.row, id);
            }).fail(err => {
                console.error(err);
                notify(Resx.Common.Error);
            });
        }
    }

    update(updateRows) {
        if (updateRows.length < 1) {
            return;
        }
        const url = `/${this._options.updateUrl}/${this._projectId}`;
        abp.ajax({
            url: url,
            type: "POST",
            data: JSON.stringify(updateRows,
                (k, v) => {
                    if (v === undefined) {
                        return null;
                    }
                    return v;
                })
        }).done(() => {
        }).fail(err => {
            console.error(err);
            notify(Resx.Common.Error);
        });
    }

    delete(id) {
        const url = `/${this._options.deleteUrl}/${this._projectId}`;
        abp.ajax({
            url: url,
            type: "POST",
            data: JSON.stringify({ rowId: id })
        }).done(() => {
        }).fail(err => {
            console.error(err);
            notify(Resx.Common.Error);
        });
    }


}



// WEBPACK FOOTER //
// ./App/components/Handsontable/apiService.js